import React from 'react';
import { Route } from 'react-router-dom';
import useTranslateWithFallback from './hooks/useTranslateWithFallback';

type NotFoundErrorPageProps = {
  text?: string;
};

export default function NotFoundErrorPage({ text }: NotFoundErrorPageProps): JSX.Element {
  const t = useTranslateWithFallback();

  return (
    <Route
      render={({ staticContext }) => {
        if (staticContext) staticContext.statusCode = 404;
        return <div>{text || t('notFoundPage/text')}</div>;
      }}
    />
  );
}
